<div class="download-banner" *ngIf="showBanner()">
  <div class="download-banner-content">

    <div class="download-banner-app-info">
      <div class="download-banner-icon">
        <img src="assets/imgs/me.svg" [attr.alt]="brandName" />
      </div>
      <div class="download-banner-text">
        <span class="download-banner-name text-12-500">{{ brandName }}</span>
        <span class="download-banner-tagline text-10-400">{{ ss.t('appDownload_tagline') }}</span>
      </div>
    </div>

    <div class="download-banner-actions">
      <button class="download-banner-get-btn" (click)="onGetApp()">
        <app-svg [name]="storeIcon" width="14" height="14" [color]="ss.theme().color16"></app-svg>
        <span class="color-16 text-12-400">{{ ss.t('appDownload_getApp') }}</span>
      </button>
      <button class="download-banner-close-btn" (click)="onDismiss()" [attr.aria-label]="ss.t('aria_dismiss')">
        <app-svg name="nativeAppDownloadBannerClose" [color]="ss.theme().color16" width="18" height="18"></app-svg>
      </button>
    </div>

  </div>
</div>
